/**
 * @generated SignedSource<<2a677d5351298e209fabbddb9d01677b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from 'relay-runtime';
export type OrganizationMemberRole = 'admin' | 'invited' | 'member' | 'owner' | '%future added value';
export type ProfileQueriesGetOrganizationMembersConnectionQuery$variables = {
  first?: number | null;
  orgId: string;
};
export type ProfileQueriesGetOrganizationMembersConnectionQuery$data = {
  readonly organizationMembers: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly 'id': string;
        readonly 'profile': {
          readonly id: string;
        };
        readonly 'role': OrganizationMemberRole;
        readonly ' $fragmentSpreads': FragmentRefs<'ProfileFragmentsOrganizationMemberInfo'>;
      } | null;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: any | null;
      readonly hasNextPage: boolean;
    };
    readonly totalCount: number;
  } | null;
};
export type ProfileQueriesGetOrganizationMembersConnectionQuery = {
  response: ProfileQueriesGetOrganizationMembersConnectionQuery$data;
  variables: ProfileQueriesGetOrganizationMembersConnectionQuery$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'first',
    },
    v1 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'orgId',
    },
    v2 = {
      kind: 'Variable',
      name: 'orgId',
      variableName: 'orgId',
    },
    v3 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'totalCount',
      storageKey: null,
    },
    v4 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'id',
      storageKey: null,
    },
    v5 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'role',
      storageKey: null,
    },
    v6 = [v4 /*: any*/],
    v7 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: '__typename',
      storageKey: null,
    },
    v8 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'cursor',
      storageKey: null,
    },
    v9 = {
      alias: null,
      args: null,
      concreteType: 'PageInfo',
      kind: 'LinkedField',
      name: 'pageInfo',
      plural: false,
      selections: [
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'endCursor',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'hasNextPage',
          storageKey: null,
        },
      ],
      storageKey: null,
    },
    v10 = [
      {
        kind: 'Variable',
        name: 'first',
        variableName: 'first',
      },
      v2 /*: any*/,
    ],
    v11 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'name',
      storageKey: null,
    },
    v12 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'avatarUrl',
      storageKey: null,
    };
  return {
    fragment: {
      argumentDefinitions: [v0 /*: any*/, v1 /*: any*/],
      kind: 'Fragment',
      metadata: null,
      name: 'ProfileQueriesGetOrganizationMembersConnectionQuery',
      selections: [
        {
          alias: 'organizationMembers',
          args: [v2 /*: any*/],
          concreteType: 'OrganizationMemberConnection',
          kind: 'LinkedField',
          name: '__organizationMembersList_organizationMembers_connection',
          plural: false,
          selections: [
            v3 /*: any*/,
            {
              alias: null,
              args: null,
              concreteType: 'OrganizationMemberEdge',
              kind: 'LinkedField',
              name: 'edges',
              plural: true,
              selections: [
                {
                  alias: null,
                  args: null,
                  concreteType: 'OrganizationMember',
                  kind: 'LinkedField',
                  name: 'node',
                  plural: false,
                  selections: [
                    v4 /*: any*/,
                    v5 /*: any*/,
                    {
                      alias: null,
                      args: null,
                      concreteType: 'Profile',
                      kind: 'LinkedField',
                      name: 'profile',
                      plural: false,
                      selections: v6 /*: any*/,
                      storageKey: null,
                    },
                    {
                      args: null,
                      kind: 'FragmentSpread',
                      name: 'ProfileFragmentsOrganizationMemberInfo',
                    },
                    v7 /*: any*/,
                  ],
                  storageKey: null,
                },
                v8 /*: any*/,
              ],
              storageKey: null,
            },
            v9 /*: any*/,
          ],
          storageKey: null,
        },
      ],
      type: 'Query',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [v1 /*: any*/, v0 /*: any*/],
      kind: 'Operation',
      name: 'ProfileQueriesGetOrganizationMembersConnectionQuery',
      selections: [
        {
          alias: null,
          args: v10 /*: any*/,
          concreteType: 'OrganizationMemberConnection',
          kind: 'LinkedField',
          name: 'organizationMembers',
          plural: false,
          selections: [
            v3 /*: any*/,
            {
              alias: null,
              args: null,
              concreteType: 'OrganizationMemberEdge',
              kind: 'LinkedField',
              name: 'edges',
              plural: true,
              selections: [
                {
                  alias: null,
                  args: null,
                  concreteType: 'OrganizationMember',
                  kind: 'LinkedField',
                  name: 'node',
                  plural: false,
                  selections: [
                    v4 /*: any*/,
                    v5 /*: any*/,
                    {
                      alias: null,
                      args: null,
                      concreteType: 'Profile',
                      kind: 'LinkedField',
                      name: 'profile',
                      plural: false,
                      selections: [
                        v4 /*: any*/,
                        {
                          alias: null,
                          args: null,
                          concreteType: 'Education',
                          kind: 'LinkedField',
                          name: 'educations',
                          plural: true,
                          selections: v6 /*: any*/,
                          storageKey: null,
                        },
                        {
                          alias: null,
                          args: null,
                          concreteType: 'SeaService',
                          kind: 'LinkedField',
                          name: 'seaServices',
                          plural: true,
                          selections: [
                            {
                              alias: null,
                              args: null,
                              concreteType: 'Vessel',
                              kind: 'LinkedField',
                              name: 'vessel',
                              plural: false,
                              selections: [
                                {
                                  alias: null,
                                  args: null,
                                  kind: 'ScalarField',
                                  name: 'imo',
                                  storageKey: null,
                                },
                                v4 /*: any*/,
                              ],
                              storageKey: null,
                            },
                            v4 /*: any*/,
                          ],
                          storageKey: null,
                        },
                        {
                          alias: null,
                          args: null,
                          concreteType: 'CertificateInfo',
                          kind: 'LinkedField',
                          name: 'certificateInfos',
                          plural: true,
                          selections: v6 /*: any*/,
                          storageKey: null,
                        },
                        {
                          alias: null,
                          args: null,
                          concreteType: 'ProfileInfo',
                          kind: 'LinkedField',
                          name: 'info',
                          plural: false,
                          selections: [
                            {
                              alias: null,
                              args: null,
                              concreteType: 'Duty',
                              kind: 'LinkedField',
                              name: 'primaryDuty',
                              plural: false,
                              selections: [v11 /*: any*/, v4 /*: any*/],
                              storageKey: null,
                            },
                            {
                              alias: null,
                              args: null,
                              concreteType: 'Country',
                              kind: 'LinkedField',
                              name: 'country',
                              plural: false,
                              selections: [
                                v11 /*: any*/,
                                {
                                  alias: null,
                                  args: null,
                                  kind: 'ScalarField',
                                  name: 'isoCode',
                                  storageKey: null,
                                },
                                v4 /*: any*/,
                              ],
                              storageKey: null,
                            },
                            {
                              alias: null,
                              args: null,
                              kind: 'ScalarField',
                              name: 'birthDate',
                              storageKey: null,
                            },
                            v12 /*: any*/,
                            {
                              alias: null,
                              args: null,
                              kind: 'ScalarField',
                              name: 'firstName',
                              storageKey: null,
                            },
                            {
                              alias: null,
                              args: null,
                              kind: 'ScalarField',
                              name: 'lastName',
                              storageKey: null,
                            },
                            v4 /*: any*/,
                          ],
                          storageKey: null,
                        },
                      ],
                      storageKey: null,
                    },
                    {
                      alias: null,
                      args: null,
                      concreteType: 'Organization',
                      kind: 'LinkedField',
                      name: 'organization',
                      plural: false,
                      selections: [v4 /*: any*/, v12 /*: any*/, v11 /*: any*/],
                      storageKey: null,
                    },
                    v7 /*: any*/,
                  ],
                  storageKey: null,
                },
                v8 /*: any*/,
              ],
              storageKey: null,
            },
            v9 /*: any*/,
          ],
          storageKey: null,
        },
        {
          alias: null,
          args: v10 /*: any*/,
          filters: ['orgId'],
          handle: 'connection',
          key: 'organizationMembersList_organizationMembers',
          kind: 'LinkedHandle',
          name: 'organizationMembers',
        },
      ],
    },
    params: {
      cacheID: '3c1f218ee300db72e5084053fa346a00',
      id: null,
      metadata: {
        connection: [
          {
            count: 'first',
            cursor: null,
            direction: 'forward',
            path: ['organizationMembers'],
          },
        ],
      },
      name: 'ProfileQueriesGetOrganizationMembersConnectionQuery',
      operationKind: 'query',
      text: 'query ProfileQueriesGetOrganizationMembersConnectionQuery(\n  $orgId: ID!\n  $first: Int\n) {\n  organizationMembers(orgId: $orgId, first: $first) {\n    totalCount\n    edges {\n      node {\n        id\n        role\n        profile {\n          id\n        }\n        ...ProfileFragmentsOrganizationMemberInfo\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ProfileFragmentsOrganizationMemberInfo on OrganizationMember {\n  id\n  profile {\n    id\n    educations {\n      id\n    }\n    seaServices {\n      vessel {\n        imo\n        id\n      }\n      id\n    }\n    certificateInfos {\n      id\n    }\n    info {\n      primaryDuty {\n        name\n        id\n      }\n      country {\n        name\n        isoCode\n        id\n      }\n      birthDate\n      avatarUrl\n      firstName\n      lastName\n      id\n    }\n  }\n  organization {\n    id\n    avatarUrl\n    name\n  }\n  role\n}\n',
    },
  };
})();

(node as any).hash = '8f77d8287ae6b89d2dc354d3f26c0287';

export default node;
